<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div [ngSwitch]="selectedPage">
                    <div *ngSwitchCase="MyWizardPage.OrderType">
                        <my-order-type-page [(includeGabapentin)]="includeGabapentin"
                                            [(selectedOrderType)]="selectedOrderType">
                        </my-order-type-page>
                    </div>
                    <div *ngSwitchCase="MyWizardPage.NursingStations">
                        <my-nursing-station-page [(nursingStations)]="allNursingStations">                                
                        </my-nursing-station-page>
                    </div>
                    <div *ngSwitchCase="MyWizardPage.Prescribers">
                        <my-prescriber-page [(prescribers)]="allPrescribers">
                        </my-prescriber-page>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <div>
                        <div class="float-left text-align-left" *ngIf="selectedPage == MyWizardPage.OrderType">
                            <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                        </div>
                        <div class="float-left text-align-left" *ngIf="selectedPage != MyWizardPage.OrderType">
                            <button class="btn btn-primary" (click)="back()">Back</button>
                        </div>
                    </div>
                </div>
                <div class="float-right text-align-right">
                    <div [ngSwitch]="selectedPage">
                        <div *ngSwitchCase="MyWizardPage.OrderType">
                            <button (click)="showNursingStationsPage()"
                                    class="btn btn-primary">
                                <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">
                                Next: Select Nursing Stations
                            </button>
                        </div>
                        <div *ngSwitchCase="MyWizardPage.NursingStations">
                            <button (click)="showPrescribersPage()"
                                    [disabled]="!hasSelectedNursingStations()"
                                    class="btn btn-primary">
                                <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">
                                Next: Select Prescribers
                                </button>
                        </div>
                        <div *ngSwitchCase="MyWizardPage.Prescribers">
                            <button (click)="generateContent()"
                                    [disabled]="!canGenerateReport()"
                                    class="btn btn-primary">
                                <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">
                                Finished: Download Report
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>